export const UNITS = {
  PC: 'PC',
  KG: 'KG',
} as const;
